// modules
import match from './match/index'
import reality from './reality/index'
import my from './my/index'
import url from './url/index'
import kchart from './kchart/index'

const modules = {
  reality,
  match,
  my,
  kchart,
  url
}

export default modules
